import React, { useEffect, useState } from "react"
import axios from "axios"
import {
  FormGroup,
  Button,
  Input,
  Modal,
  ModalBody,
  ModalHeader,
  Form,
  Label,
  Col,
  Container,
  Card,
  CardBody,
} from "reactstrap"
import { useLocation } from "react-router-dom"
import { toast } from "react-toastify"

const DynamicEditComponent = () => {
  const [data, setData] = useState([])
  const [error, setError] = useState("")
  const [answers, setAnswers] = useState({})
  const token = JSON.parse(localStorage.getItem("Token"))
  const { state } = useLocation()
  const { value = "" } = state || {}

  const handleChangeCustom = (e, fieldId) => {
    const { value } = e.target
    setAnswers(prev => ({
      ...prev,
      [fieldId]: value,
    }))
  }

  const handleCheckboxChange = (fieldId, optionId, checked) => {
    setAnswers(prev => {
      const currentValues = prev[fieldId] || []
      return {
        ...prev,
        [fieldId]: checked
          ? [...currentValues, optionId]
          : currentValues.filter(val => val !== optionId),
      }
    })
  }

  const UpdateCustomField = async fieldId => {
    const answer = answers[fieldId]

    if (
      answer === undefined ||
      (Array.isArray(answer) && answer.length === 0)
    ) {
      toast.error("Please fill or select a value before updating.")
      return
    }

    try {
      const payload = {
        acad_id: localStorage.getItem("acad_id"),
        field_id: fieldId,
        answer: Array.isArray(answer) ? answer.join(",") : answer,
      }

      await axios.post(
        "https://marcopolo.prisms.in/api/StudentProfilePic/update-dynamic-field",
        payload,
        {
          headers: { Authorization: token },
        }
      )

      toast.success("Updated Successfully ✅")
    } catch (err) {
      console.error("Update failed:", err)
      toast.error("Update failed ❌")
    }
  }

  useEffect(() => {
    const getParentEditableInfo = async () => {
      try {
        const res = await axios.post(
          "https://marcopolo.prisms.in/api/StudentProfilePic/get-dynamic-field",
          {
            acad_id: localStorage.getItem("acad_id"),
          },
          {
            headers: { Authorization: token },
          }
        )

        setData(res.data.data || [])
      } catch (err) {
        setError("Failed to load profile data. Please try again.")
      }
    }

    getParentEditableInfo()
  }, [])

  return (
    <div className="page-content">
      <Container className="p-0">
        <Card className="p-0 shadow-sm rounded-3">
          <CardBody className="p-3">
            <Form>
              <FormGroup>
                {data.map(item => {
                  if (item.editable_by_parents === 0) return null

                  const optionList =
                    item.options?.split(",").map(opt => opt.trim()) || []
                  const idList =
                    item.opt_id?.split(",").map(id => id.trim()) || []

                  return (
                    <Col key={item.field_id} className="d-flex flex-column mt-3">
                      <Label className="fw-bold">{item.field_title}</Label>

                      {/* Select Field */}
                      {item.answer_type === "select" && (
                        <Input
                          type="select"
                          onChange={e =>
                            handleChangeCustom(e, item.field_id)
                          }
                          value={answers[item.field_id] || ""}
                        >
                          <option value="">{`Select ${item.field_title}`}</option>
                          {optionList.map((opt, idx) => (
                            <option key={idx} value={idList[idx]}>
                              {opt}
                            </option>
                          ))}
                        </Input>
                      )}

                      {/* Text Field */}
                      {item.answer_type === "text" && (
                        <Input
                          type="text"
                          placeholder={`Enter ${item.field_title}`}
                          onChange={e =>
                            handleChangeCustom(e, item.field_id)
                          }
                          value={answers[item.field_id] || ""}
                        />
                      )}

                      {/* Textarea Field */}
                      {item.answer_type === "textarea" && (
                        <Input
                          type="textarea"
                          placeholder={`Enter ${item.field_title}`}
                          onChange={e =>
                            handleChangeCustom(e, item.field_id)
                          }
                          value={answers[item.field_id] || ""}
                        />
                      )}

                      {/* Radio Group */}
                      {item.answer_type === "radio-group" &&
                        optionList.map((opt, idx) => (
                          <FormGroup check inline key={idx}>
                            <Label check>
                              <Input
                                type="radio"
                                name={item.field_title}
                                value={idList[idx]}
                                checked={
                                  answers[item.field_id] === idList[idx]
                                }
                                onChange={e =>
                                  handleChangeCustom(e, item.field_id)
                                }
                              />
                              {opt}
                            </Label>
                          </FormGroup>
                        ))}

                      {/* Checkbox Group */}
                      {item.answer_type === "checkbox-group" &&
                        optionList.map((opt, idx) => {
                          const checked =
                            (answers[item.field_id] || []).includes(
                              idList[idx]
                            )
                          return (
                            <FormGroup check inline key={idx}>
                              <Label check>
                                <Input
                                  type="checkbox"
                                  value={idList[idx]}
                                  checked={checked}
                                  onChange={e =>
                                    handleCheckboxChange(
                                      item.field_id,
                                      idList[idx],
                                      e.target.checked
                                    )
                                  }
                                />
                                {opt}
                              </Label>
                            </FormGroup>
                          )
                        })}

                      {/* Update Button */}
                      <div className="mt-2">
                        <Button
                          color="success"
                          size="sm"
                          onClick={() => UpdateCustomField(item.field_id)}
                        >
                          Update
                        </Button>
                      </div>
                    </Col>
                  )
                })}
              </FormGroup>
            </Form>
          </CardBody>
        </Card>
      </Container>
    </div>
  )
}

export default DynamicEditComponent
